import './ziggy-global';
import './bootstrap/client';
import '../css/app.css';
import '@fontsource/open-sans/index.css';
import '@fontsource/ubuntu/index.css';
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { i18nVue } from "laravel-vue-i18n";
import { route } from 'ziggy-js';
import { Ziggy } from './ziggy';
import { createPinia } from "pinia";
import axios from "axios";
// ======================
// TIPPY (FIXED)
// ======================
import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import "@fortawesome/fontawesome-free/css/all.css";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPencilAlt, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { router } from '@inertiajs/vue3';
library.add(faPencilAlt, faTrashCan, faXTwitter);
// Toast
import { toastBus } from './utils/toastBus';
import Toast from './Application/Components/Content/Toast.vue';
// ClientOnly
import ClientOnly from "@/Application/Components/ClientOnly.vue";
if (typeof window !== 'undefined') {
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
        if (key === 'theme') {
            console.trace('🔥 THEME WIRD GESETZT:', value);
        }
        return originalSetItem.apply(this, arguments);
    };
    // console.log('🔥 APP START THEME:', localStorage.getItem('theme'));
}
// ======================
// SSR SAFE FIXES
// ======================
if (typeof window !== 'undefined' && window.trustedTypes) {
    window.trustedTypes.createPolicy('default', {
        createScript: (input) => input,
        createScriptURL: (input) => input
    });
}
if (typeof global === 'undefined') {
    window.global = window;
}
// ======================
// SAFE ROUTE
// ======================
function safeRoute(name, params = {}) {
    try {
        return route(name, params, false, Ziggy);
    } catch (e) {
        console.error(e);
        throw e;
    }
}
// ======================
// AXIOS
// ======================
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// ======================
// AXIOS INTERCEPTORS (GLOBAL)
// ======================
if (typeof window !== 'undefined') {
    let pendingRequests = 0;
    axios.interceptors.request.use((config) => {
        pendingRequests++;
        window.dispatchEvent(new CustomEvent("axios:start", {
            detail: { pendingRequests }
        }));
        return config;
    });
    axios.interceptors.response.use(
        (response) => {
            pendingRequests--;
            window.dispatchEvent(new CustomEvent("axios:finish", {
                detail: { pendingRequests }
            }));
            return response;
        },
        (error) => {
            pendingRequests--;
            window.dispatchEvent(new CustomEvent("axios:finish", {
                detail: { pendingRequests }
            }));
            if (error.response?.status === 401) {
                console.error("[AXIOS 401]", {
                    url: error.config?.url || null,
                    method: error.config?.method || null,
                    status: error.response.status,
                    response: error.response.data ?? null,
                    page: window.location.href
                });
            }
            return Promise.reject(error);
        }
    );
}
if (typeof document !== 'undefined') {
    const token = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");
    if (token) {
        axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
    }
}
// ======================
// INERTIA EVENTS
// ======================
const skipLoaderFor = (url) => {
    try {
        const path = new URL(url, window.location.origin).pathname;
        return /\/shop(?:\/|$)/i.test(path); // Shop-Seite vom Loader ausschließen
    } catch {
        return false;
    }
};
router.on("start", (event) => {
    const visit = event.detail?.visit;
    if (visit?.skipLoading || skipLoaderFor(visit?.url)) return;
    window.dispatchEvent(new CustomEvent("loader:show"));
});
router.on("finish", (event) => {
    const visit = event.detail?.visit;
    if (visit?.skipLoading || skipLoaderFor(visit?.url)) return;
    window.dispatchEvent(new CustomEvent("loader:hide"));
});
// ======================
// GLOBAL JS ERROR LOGGING
// ======================
if (typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
        axios.post('/api/log-js-error', {
            type: 'window-error',
            message: event.message,
            file: event.filename,
            line: event.lineno,
            column: event.colno,
            stack: event.error?.stack || null,
            url: window.location.href,
        }).catch(() => {});
    });
    window.addEventListener('unhandledrejection', (event) => {
        axios.post('/api/log-js-error', {
            type: 'promise',
            message: event.reason?.message || String(event.reason),
            stack: event.reason?.stack || null,
            url: window.location.href,
        }).catch(() => {});
    });
}
import { SD } from "@/helpers";
// ======================
// APP
// ======================
let alr = false;
// router.on('navigate', (event) => {
//     console.log('NAVIGATE', event.detail.page.url);
//      const url = btoa(encodeURIComponent(
//         event.detail.page.url
//     ));
//     const route =
//         event.detail.page.props.route_name ??
//         'unknown';
//     const page =
//         event.detail.page.props.get_page ??
//         '';
//     axios.get(
//         `/countpixel/${url}/${route}/${page}`
//     )
//     .then(() => {
//         console.log('TRACK OK',url);
//         alr = true;
//     })
//     .catch((e) => {
//         console.error('TRACK ERROR', e);
//     });
// });
router.on('success', (event) => {
    const url = btoa(encodeURIComponent(
        event.detail.page.url
    ));
    const route =
        event.detail.page.props.route_name ?? 'unknown';
    const page =
        event.detail.page.props.get_page ?? '';
    axios.get(`/countpixel/${url}/${route}/${page}`);
    console.log("NAvig to: " + event.detail.page.url)
});
router.on('finish', (event) => {
});
window.addEventListener(
    'unhandledrejection',
    (event) => {
        const msg =
            event.reason?.message ||
            String(event.reason);
        if (msg.includes(
                'Failed to fetch dynamically imported module')) {
            window.location.reload();
        }
    }
);
// router.on('success', (event) => {
//     const url_allt = event.detail.page.url;
//     console.log('TRACK', url_allt);
//     const encoded = btoa(encodeURIComponent(url_allt));
//      axios.get('/countpixel', {
//          params: {
//         url: encoded,
//         route: event.detail.page.props.route_name,
//         page: event.detail.page.props.get_page
//     }
//     }).then((r) => {
//         console.log('COUNTPIXEL OK', r);
//     }).catch(err => {
//         console.error(err);
//     });
// });
createInertiaApp({
    title: title => title,
    resolve: async (name) => {
    // console.log('Loading page:', name);
    const page = await resolvePageComponent(
        `./Application/${name}.vue`,
        import.meta.glob("./Application/**/*.vue")
    );
    // console.log('Page loaded:', page);
    return page;
},
    setup({ el, App, props, plugin }) {
        // SSR/browser helper context
        globalThis.page = props;
        if (typeof window !== 'undefined') {
            window.page = props;
        } 
        if (!el) {
            console.error("Inertia mount Element fehlt!");
            return;
        }
        const app = createApp({
            render: () => h(App, props),
        });
        // Plugins
        app.use(createPinia());
        app.use(plugin);
        app.config.errorHandler = (err, instance, info) => {
            console.group("Vue Error");
            console.error(err);
            console.log("Info:", info);
            console.log("Component:", instance?.$?.type?.name);
            console.log("File:", instance?.$?.type?.__file);
            console.log(instance);
            console.groupEnd();
            axios.post('/api/log-js-error', {
                message: err?.message || String(err),
                stack: err?.stack || null,
                info,
                url: window.location.href,
                component: instance?.$options?.name || null,
            }).catch(() => {});
        };
        // ======================
        // TIPPY FIX (WICHTIG)
        // ======================
        app.use(VueTippy, {
            directive: 'tippy',
            component: 'tippy',
            defaultProps: {
                placement: 'top',
                allowHTML: true,
            }
        });
        // i18n
        app.use(i18nVue, {
            resolve: async lang => {
                const langs = import.meta.glob("../../lang/*.json");
                if (!langs[`../../lang/${lang}.json`]) return {};
                return await langs[`../../lang/${lang}.json`]();
            },
        });
        // Components
        app.component("font-awesome-icon", FontAwesomeIcon);
        app.component("Toast", Toast);
        app.component("ClientOnly", ClientOnly);
        // Globals
        app.config.globalProperties.$route = safeRoute;
        app.config.globalProperties.route = safeRoute;
        app.config.globalProperties.$toast = toastBus;
        if (typeof window !== 'undefined') {
            window.route = safeRoute;
            window.toastBus = toastBus;
            window.toast = (type, message, duration = 5000) =>
                toastBus.emit({ type, message, duration });
        }
        app.mount(el);
        // ======================
        // REST DEINER LOGIK (UNVERÄNDERT)
        // ======================
        if (props.flash?.needsReload && !sessionStorage.getItem('needsReload')) {
            sessionStorage.setItem('needsReload', '1');
            window.location.reload();
        } else if (sessionStorage.getItem('needsReload')) {
            sessionStorage.removeItem('needsReload');
        }
        // async function loadDarkMode() {
        //     let mode = localStorage.getItem("theme") || "light";
        //     try {
        //         const response = await fetch("/api/dark-mode");
        //         const data = await response.json();
        //         mode = data.darkMode || mode;
        //     } catch (e) {}
        //     localStorage.setItem("theme", mode);
        //     document.documentElement.setAttribute("data-theme", mode);
        // }
        if (typeof window !== 'undefined') {
            // loadDarkMode();
        }
        if (typeof window !== 'undefined') {
            window.$_GET = {};
            const query = window.location.search.substring(1);
            if (query) {
                query.split('&').forEach(param => {
                    const [key, val] = param.split('=').map(decodeURIComponent);
                    window.$_GET[key] = val;
                });
            }
        }
        if (typeof window !== 'undefined') {
            let oldUrl = window.location.href;
            window.addEventListener('beforeunload', function () {
                const newUrl = document.activeElement?.href || '';
                if (newUrl && newUrl !== oldUrl) {
                    navigator.sendBeacon('/unset-session.php');
                }
            });
        }
    },
    progress: {
        color: "#0EA5E9",
    },
});
